<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
    <div *ngIf="IsOnline !== true" fxLayout="column" fxLayoutAlign="center center" fxFlex="30">
        <h1>Polk Awards is currently offline</h1>
        <p>
            Sorry for the inconvenience.
            This is likely due to maintenance being done to the system.
            Please check back later.
        </p>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-around center" fxLayout.lt-md="column" *ngIf="IsOnline === true && ViewReady === true" >
        <div class="inner welcomebox mat-elevation-z10">
            <mat-toolbar color="primary"> <span>Welcome!</span> </mat-toolbar>
            <div><span [innerHTML]="AwardInfo?.LoginWelcome | safeHTML"></span></div>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-around center">
            <div class="topbox loginform" *ngIf="AwardInfo?.ShortName === 'HOF'">
                <div class="inner mat-elevation-z10">
                    <mat-toolbar color="accent"> <span>Nomination Form</span> </mat-toolbar>
                    <div class="nominate">
                        <button mat-raised-button type="button" color="primary" routerLink="../nominate">
                            Nominate
                        </button>
                    </div>
                </div>
            </div>
            <div class="topbox loginform">
                <form class="inner mat-elevation-z10" #staffForm="ngForm" (ngSubmit)="staffLogin(staffForm.value)" novalidate>
                    <div fxFlexFill fxLayout="column" fxLayoutAlign="space-between stretch">
                        <div fxLayout="column" fxLayoutAlign="start center">
                            <mat-toolbar color="accent"> <span>Staff Login</span> </mat-toolbar>
                            <mat-form-field appearance="outline">
                                <input matInput placeholder="Username" name="username" id="username" ngModel required autofocus />
                                <mat-icon matSuffix>person</mat-icon>
                                <mat-hint align="left">District staff: Please use firstname.lastname only</mat-hint>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <input matInput placeholder="Password" type="password" name="password" id="password" ngModel />
                                <mat-icon matSuffix appMobileTap (click)="ShowImpersonation($event)">lock_outline</mat-icon>
                            </mat-form-field>
                            <mat-form-field *ngIf="ShowImpersonationBox" appearance="outline">
                                <input matInput placeholder="Impersonated Account/UserID" type="text" name="impersonated" id="impersonated" ngModel/>
                                <mat-icon matSuffix>account_circle</mat-icon>
                            </mat-form-field>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutWrap>
                            <div>
                                <button mat-raised-button type="submit" color="primary" [disabled]="(staffForm.invalid && staffForm.dirty) || LoginInProgress">
                                    Login
                                </button>
                            </div>
                            <div>
                                <button mat-button color="warn" href="https://password.mypolkschools.net/?from=PolkAwards&award=TOY">Forgot Password?</button>
                            </div>
                            <div><button mat-raised-button color="accent" type="button" (click)="staffForm.reset()">Reset</button></div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="topbox loginform" *ngIf="AwardInfo?.IsJudged">
                <form class="inner mat-elevation-z10" #judgeForm="ngForm" (ngSubmit)="judgeLogin(judgeForm.value)" novalidate>
                    <div fxFlexFill fxLayout="column" fxLayoutAlign="space-between stretch">
                        <div fxLayout="column" fxLayoutAlign="start center">
                            <mat-toolbar color="accent"> <span>Judge Login</span> </mat-toolbar>
                            <mat-form-field appearance="outline">
                                <input matInput placeholder="Judging Key" type="text" name="judgingKey" id="judgingKey" ngModel />
                                <mat-icon matSuffix>vpn_key</mat-icon>
                            </mat-form-field>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutWrap>
                            <div>
                                <button mat-raised-button type="submit" color="primary" [disabled]="judgeForm.invalid || LoginInProgress">
                                    Login
                                </button>
                            </div>
                            <div mat-button color="warn" (click)="LostKey()">Lost Judging Key?</div>
                            <div><button mat-raised-button color="accent" type="button" (click)="judgeForm.reset()">Reset</button></div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
